/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>

module DealerwareWebComponents {
    "use strict";
    import IReports = DealerwareWebComponents.IReportsConfiguration

    getDealerwareWebComponentsModule().constant(
        'apiToGridMapVehiclesUtilization', {
            year: 'model_year',
            days: 'utilized_days_count'
        }
    );

    export interface IUtilizationReportonfiguration extends ng.IScope {
        initFilterMonthAndYear(): void;
        resetToInitialData()    : void;
    }

    export class ReportsUtilizationDirectiveController {

        public static $inject : string[ ] = [
            '$scope',
            '$q',
            '$state',
            '$filter',
            '$mdDialog',
            'apiToGridMapVehiclesUtilization',
            'DealerwareVehicleCollection',
            '$dealerwareNotification',
            '$controller',
            'uiGridConstants',
            '$dealerwareInternationalizationData'
        ];

        public filterMonth: number;
        public filterYear: number;

        // Just for linting.  Seemingly externalGridFilters is not being properly traced
        // back to ReportsController below in resetToInitialDataRetainingSorts.
        //
        public externalGridFilters: string[];

        private configuration: IReports;
        private gridColumns: any;
        private reports: any = { };
        private filterDateString: string;
        private defaultGridFilters: any;
        private exportDataLoadedDefer: ng.IDeferred<any> = this.$q.defer();
        private defaultGridSorts: any = {
            sort_by: 'utilization',
            sort_direction: 'desc'
        };

        public labels: {};

        constructor(private $scope: IUtilizationReportonfiguration,
                    private $q: ng.IQService,
                    private $state: any,
                    private $filter: any,
                    private $mdDialog: any,
                    private apiToGridMapVehiclesUtilization: any,
                    private DealerwareVehicleCollection: any,
                    private $dealerwareNotification: any,
                    private $controller: any,
                    private uiGridConstants: any,
                    public $dealerwareInternationalizationData   : any) {
            
            this.getLabels('vehicles');
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                    _self.labels.columnHeaders = _self.$dealerwareInternationalizationData.formatLabelsByLanguage(localStorage.getItem('language'), _self.labels.columnHeaders);
                    _self.initColumns();
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public initColumns() : void {
            var that = this,
            currentYear: number = moment().year(),
            startYear: number = currentYear - 6,
            yearOptions: {}[] = [],
            dateTemplate = 'dealerware-utilization-date-filter',
            numericTemplate = 'dealerware-utilization-numeric-filter',
            filterHeaderHtml = '<div class="report-filter-button-container">'
                + '<md-button class="md-icon-button" style="margin: 0;" aria-label="Refresh" '
                + 'ng-click="col.colDef.showModal(this)">'
                + '<md-icon md-svg-icon="filter" class="icon-filter"></md-icon>'
                + '</md-button>'
                + '</div>';

            for (var y = currentYear + 1; y >= startYear + 1; y--) {
                yearOptions.push({ value: y, label: y.toString() });
            }

            this.gridColumns = [{
                name: 'VIN',
                displayName: that.labels.columnHeaders.vin,
                field: 'vin',
                renderHtml: true,
                visible: true,
                formatCallback: function() {
                    return that.reports.dataUtils.isBlank(this.vin) ? '' :
                        '<a class="reports-utilization-table-cell-vin" href="' + that.$state.href('root.private.application.vehicles.details',
                            { vehicleId: this.car_id }
                        ) + '">' + this.vin + '</a>';
                }
            },{
                name: 'License Plate',
                displayName: that.labels.columnHeaders.license_plate,
                field: 'license_plate',
                renderHtml: true,
                visible: true,
                formatCallback: function() {
                    return that.reports.dataUtils.isBlank(this.license_plate) ? '' :
                        '<a class="reports-utilization-table-cell-license-plate" href="' + that.$state.href('root.private.application.vehicles.details',
                            { vehicleId: this.car_id }
                        ) + '">' + this.license_plate + '</a>';
                }
            },{
                name: 'Stock #',
                displayName: that.labels.columnHeaders.stock_number,
                field: 'stock_number',
                visible: true,
                formatCallback: function() {
                    return that.reports.dataUtils.isBlank(this.stock_number)
                        || this.stock_number === 'NULL' ? '' : this.stock_number;
                }
            },{
                name: 'Year',
                displayName: that.labels.columnHeaders.year,
                field: 'model_year',
                visible: false,
                filter: {
                    type: that.uiGridConstants.filter.SELECT,
                    selectOptions: yearOptions
                }
            },{
                name: 'Make',
                displayName: that.labels.columnHeaders.make,
                field: 'make',
                visible: false
            },{
                name: 'Model',
                displayName: that.labels.columnHeaders.model,
                field: 'model',
                visible: false
            },{
                name: 'Available Days',
                displayName: that.labels.columnHeaders.available_days,
                field: 'available_days_count',
                visible: true,
                useExternalFilter: true,
                showModal: function(columnScope: any) {
                    if (!columnScope.col.modalData) {
                        columnScope.col.modalData = {
                            type: 'between',
                            startRange: 0,
                            endRange: 10
                        };
                    }

                    columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                    var filterField = 'available_days_count';

                    that.reports.setFilterControlData(filterField, {
                        title: this.name,
                        field: filterField,
                        template: numericTemplate,
                        gridColumn: columnScope.col,
                        calculateFilterFunction: that.reports.calculateNumericFilter
                    });

                    that.reports.showFilterModal(filterField);
                },
                filterHeaderTemplate: filterHeaderHtml,
                cellClass           : 'ui-grid-cell-contents-number'
            },{
                name: 'Utilized Days',
                displayName: that.labels.columnHeaders.utilized_days,
                field: 'utilized_days_count',
                visible: true,
                useExternalFilter: true,
                showModal: function(columnScope: any) {
                    if (!columnScope.col.modalData) {
                        columnScope.col.modalData = {
                            type: 'between',
                            startRange: 0,
                            endRange: 10
                        };
                    }

                    columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                    var filterField = 'days';

                    that.reports.setFilterControlData(filterField, {
                        title: this.name,
                        field: filterField,
                        template: numericTemplate,
                        gridColumn: columnScope.col,
                        calculateFilterFunction: that.reports.calculateNumericFilter
                    });

                    that.reports.showFilterModal(filterField);
                },
                filterHeaderTemplate: filterHeaderHtml,
                cellClass           : 'ui-grid-cell-contents-number'
            },{
                name: 'Utilization',
                displayName: that.labels.columnHeaders.utilization,
                field: 'utilization',
                visible: true,
                useExternalFilter: true,
                formatCallback: function() {
                    return that.reports.dataUtils.isBlank(this.utilization) ? '0%' :
                        Math.round(this.utilization * 100) + '%';
                },
                showModal: function(columnScope: any) {
                    if (!columnScope.col.modalData) {
                        columnScope.col.modalData = {
                            type: 'between',
                            startRange: 0,
                            endRange: 25,
                            valueTransform: (rawValue: number) => {
                                return rawValue/100;
                            }
                        };
                    }

                    columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                    var filterField = 'utilization';

                    that.reports.setFilterControlData(filterField, {
                        title: this.name,
                        field: filterField,
                        template: numericTemplate,
                        gridColumn: columnScope.col,
                        calculateFilterFunction: that.reports.calculateNumericFilter
                    });

                    that.reports.showFilterModal(filterField);
                },
                filterHeaderTemplate: filterHeaderHtml,
                cellClass           : 'ui-grid-cell-contents-number'
            },{
                name: 'Contract Days',
                displayName: that.labels.columnHeaders.contract_days,
                field: 'contract_days_count',
                visible: true,
                useExternalFilter: true,
                showModal: function(columnScope: any) {
                    if (!columnScope.col.modalData) {
                        columnScope.col.modalData = {
                            type: 'between',
                            startRange: 0,
                            endRange: 10
                        };
                    }

                    columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                    var filterField = 'contract_days_count';

                    that.reports.setFilterControlData(filterField, {
                        title: this.name,
                        field: filterField,
                        template: numericTemplate,
                        gridColumn: columnScope.col,
                        calculateFilterFunction: that.reports.calculateNumericFilter
                    });

                    that.reports.showFilterModal(filterField);
                },
                filterHeaderTemplate: filterHeaderHtml,
                cellClass           : 'ui-grid-cell-contents-number'
            },{
                name: 'Contract Days Utilization',
                displayName: that.labels.columnHeaders.contract_days_utilization,
                field: 'contract_days_utilization',
                visible: true,
                useExternalFilter: true,
                formatCallback: function() {
                    return that.reports.dataUtils.isBlank(this.contract_days_utilization) ? '0%' :
                        Math.round(this.contract_days_utilization * 100) + '%';
                },
                showModal: function(columnScope: any) {
                    if (!columnScope.col.modalData) {
                        columnScope.col.modalData = {
                            type: 'between',
                            startRange: 0,
                            endRange: 25,
                            valueTransform: (rawValue: number) => {
                                return rawValue/100;
                            }
                        };
                    }

                    columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                    var filterField = 'contract_days_utilization';

                    that.reports.setFilterControlData(filterField, {
                        title: this.name,
                        field: filterField,
                        template: numericTemplate,
                        gridColumn: columnScope.col,
                        calculateFilterFunction: that.reports.calculateNumericFilter
                    });

                    that.reports.showFilterModal(filterField);
                },
                filterHeaderTemplate: filterHeaderHtml,
                cellClass           : 'ui-grid-cell-contents-number'
            },{
                name: 'Total Contracts',
                displayName: that.labels.columnHeaders.total_contracts,
                field: 'total_contracts_count',
                visible: true,
                useExternalFilter: true,
                showModal: function(columnScope: any) {
                    if (!columnScope.col.modalData) {
                        columnScope.col.modalData = {
                            type: 'between',
                            startRange: 0,
                            endRange: 10
                        };
                    }

                    columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                    var filterField = 'total_contracts_count';

                    that.reports.setFilterControlData(filterField, {
                        title: this.name,
                        field: filterField,
                        template: numericTemplate,
                        gridColumn: columnScope.col,
                        calculateFilterFunction: that.reports.calculateNumericFilter
                    });

                    that.reports.showFilterModal(filterField);
                },
                filterHeaderTemplate: filterHeaderHtml,
                cellClass           : 'ui-grid-cell-contents-number'
            }];

            this.initMonthSelectWatcher();
            this.setReportsConfiguration();
        }

        public loadHeadersForExport() : ng.IPromise<any> {
            return this.exportDataLoadedDefer.promise
                .then( ( columns: any[] ) => {
                    return columns.map( ( column: any ) => {
                        return column.name;
                    });
                });
        }

        public getUsDayKey(dayKey: string) : string {
            return dayKey.replace(/^(\d{4})\-(\d{2})\-(\d{2})$/, '$2/$3/$1');
        }

        public getExportColumns(row: any, exportColumns: any[]) : any[] {
            var that = this,
                dayKeyUs: string,
                dateColumns: any[] = [ ];

            // Flatten out utilization days into main vehicle object.
            Object.keys(row.utilized_days).sort().forEach((dayKey: string) => {
                dayKeyUs = that.getUsDayKey(dayKey);

                // Add a gridColumn for each utilization day.
                dateColumns.push({
                    name: dayKeyUs,
                    field: dayKeyUs,
                    visible: true
                })
            });

            exportColumns.splice(
                (function() {
                    var spliceStartIndex = 0;

                    jQuery.each(exportColumns, (index: number, column: any) => {
                        spliceStartIndex++;
                        return column.field !== 'days';
                    });

                    return spliceStartIndex;
                })(), 0, ...dateColumns
            );

            return exportColumns;
        }

        public setExportRows(rows: any[]) : void {
            var that = this;

            // Add utilization day data to the CSV report.
            rows.forEach((row: any, i: number) => {
                // Flatten out utilization days into main vehicle object.
                Object.keys(row.utilized_days).sort().forEach((dayKey: string) => {
                    rows[i][that.getUsDayKey(dayKey)] = row.utilized_days[dayKey];
                });
            });
        }

        public loadThisPageDataForExport() : ng.IPromise<any> {
            return this.loadPageDataForExport('loadThisPageDataForExport');
        }

        public loadAllDataForExport() : ng.IPromise<any> {
            return this.loadPageDataForExport('loadAllDataForExport');
        }

        public loadPageDataForExport(loadMethod: string) : ng.IPromise<any> {
            var that = this,
                defer = this.$q.defer();

            this.reports[loadMethod]().then((rows: any) => {
                if (rows.length) {
                    var exportColumns = that.getExportColumns(rows[0], angular.copy(that.reports.gridColumnDefs));
                    that.setExportRows(rows);

                    // Send in the cars.
                    defer.resolve({ rows: rows, columns: exportColumns });

                    // Getting all the data was necessary in order to know what the CSV column headers
                    // text is, so resolve that promise too so that ng-csv's header method obtains
                    // said headers.
                    this.exportDataLoadedDefer.resolve(exportColumns);
                    this.exportDataLoadedDefer = this.$q.defer();
                } else {
                    defer.resolve([]);
                }
            });

            return defer.promise;
        }

        public setReportsConfiguration() : void {
            var that = this;

            // This report's configuration.
            this.configuration = {
                grid: {
                    defaultSorts: this.defaultGridSorts,
                    defaultFilters: this.defaultGridFilters,
                    columnMap: this.apiToGridMapVehiclesUtilization,
                    columns: this.gridColumns
                },
                collection: {
                    model: this.DealerwareVehicleCollection,
                    loadMethod: 'utilization',
                },
                $scope: this.$scope
            };

            // Add base controller members to this report.
            this.reports = this.$controller('ReportsController', {
                thisReportConfiguration : this.configuration,
                '$scope'                : this.$scope
            });

            // This has to be put on the main reports controller, unlike resetToInitialData
            // which does almost the same thing but is on this controller, because of
            // (function) scoping difficulties in the grid.  There's not a real need
            // to genericize it.
            //
            this.reports.reloadInitialDataForThisReport = ( ) => {
                that.initFilterMonthAndYear();
                that.reports.resetToInitialDataRetainingSorts();
            };

            // CSV config uses bases ReportsController methods for dataLoading,
            // but they could be custom for this report.
            var exportFileName = 'vehicle_utilization_' + moment().format('YYYY_MM_DD') + '.csv';
            this.configuration.csvExport = {
                showExporterMenu: false,
                thisPage: {
                    fileName: exportFileName,
                    dataLoadMethod: () => {
                        // Switch scope of load method to this controller's
                        return this.loadThisPageDataForExport.call(that);
                    },
                    headersLoadMethod: () => {
                        // Switch scope of load method to this controller's.
                        return this.loadHeadersForExport.call(that);
                    }
                },
                allPages: {
                    fileName: exportFileName,
                    dataLoadMethod: () => {
                        return this.loadAllDataForExport.call(that);
                    },
                    headersLoadMethod: () => {
                        return this.loadHeadersForExport.call(that);
                    },
                    sort: {
                        by: 'utilization',
                        direction: 'desc'
                    }
                }
            };

            // update the export filename to add location name after the location has loaded
            //
            // I suspect this is no longer needed because, on pageload, the filterMonth/Year watcher
            // (which also sets the export filename now) seems to absolutely fire after locationName is set,
            // i.e. after this watcher fires, therefore insuring there is a proper filename for the .csv export.
            // But in the off chance  there's a race condition going on, I don't see much harm in
            // (potentially redundantly) setting the export filename here.
            var cancelExportedCsvFileNameWatcher = this.$scope.$watch(() => {
                return this.reports.locationName;
            }, (locationName: string) => {
                if (locationName) {
                    this.setExportedCsvFileName();

                    // And it can be safely cancelled after one use since the location name can only
                    // be changed after navigating away from this page.
                    cancelExportedCsvFileNameWatcher();
                }
            });

            // Clearing data callbacks.  I really don't know if this is legit.  $scope is kinda the
            // property of the template, and these are called from the template, so at least there's
            // the suggestion of a justification.
            //
            this.$scope.initFilterMonthAndYear = this.initFilterMonthAndYear;
            this.$scope.resetToInitialData = this.resetToInitialData;
        }

        // Refresh button callback is run in the context of this controller,
        // ReportsUtilizationDirectiveController.
        //
        public resetToInitialData() : void {
            this.reports.externalGridFilters = [ ];
            this.reports.thisReport.$scope.initFilterMonthAndYear.call(this);
            this.reports.resetToInitialData();
        }

        // Grid Clear ALL Filters callback is run in the scope of the context of
        // ReportsController controller
        //
        public resetToInitialDataRetainingSorts() : void {
            this.externalGridFilters = [ 'start_date', 'end_date' ];
            this.resetToInitialData();
        }

        public setExportedCsvFileName () : void {
            if (this.reports.locationName) {
                var exportFileName = this.$filter('spaceless')(this.reports.locationName.toLowerCase()) + '_vehicle_utilization_' + this.filterYear + '_' + this.$filter('zeropad')(this.filterMonth, 2) + '.csv';

                this.configuration.csvExport.thisPage.fileName = exportFileName;
                this.configuration.csvExport.allPages.fileName = exportFileName;
            }
        }

        public initFilterMonthAndYear() : void {
            var now = moment();

            this.filterMonth = now.month() === 0 ? parseInt(moment().month('December').format('M')) : now.month();
            this.filterYear = now.month() === 0 ? now.year() - 1 : now.year();
        }

        public initMonthSelectWatcher() : void {

            this.initFilterMonthAndYear();

            this.defaultGridFilters = {
                start_date: { matches: moment(this.filterMonth + '-1-' + this.filterYear, 'M-D-YYYY').format('YYYY-MM-DD') },
                end_date: { matches: moment(this.filterMonth + '-1-' + this.filterYear, 'M-D-YYYY').endOf('month').format('YYYY-MM-DD') }
            };

            this.$scope.$watchGroup([
                () => { return this.filterMonth },
                () => { return this.filterYear },
                () => { return this.reports.loading }
            ], (newValues, oldValues) => {
                var dateString = newValues[0] + '-1-' + newValues[1];

                if (newValues !== oldValues && !newValues[2] && this.filterDateString && dateString !== this.filterDateString) {
                    this.reports.loadDataWithSortsAndFilters(null, {
                        start_date: moment(dateString, 'M-D-YYYY').format('YYYY-MM-DD'),
                        end_date: moment(dateString, 'M-D-YYYY').endOf('month').format('YYYY-MM-DD')
                    });
                }

                this.filterDateString = dateString;

                this.setExportedCsvFileName();
            });
        }

        public showHelpModal() : void {
            this.$mdDialog.show({
                templateUrl: '/components/reports/utilization/utilization-definitions.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                controller: ($scope: any, $mdDialog: any) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    }
                }
            });
        }
    }

    getDealerwareWebComponentsModule().controller(
        'ReportsUtilizationDirectiveController',
        ReportsUtilizationDirectiveController
    );


    export class ReportsUtilizationDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ReportsUtilizationDirectiveController';
        public controllerAs     : string    =   'vm';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/reports/utilization/utilization-directive.html';
        public scope            : Object    =   {};
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareReportsUtilization',
        () => new ReportsUtilizationDirective()
    );
}

